import { render, staticRenderFns } from "./qualificationReview.vue?vue&type=template&id=059d7c86&scoped=true"
import script from "./qualificationReview.vue?vue&type=script&lang=js"
export * from "./qualificationReview.vue?vue&type=script&lang=js"
import style0 from "./qualificationReview.vue?vue&type=style&index=0&id=059d7c86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d7c86",
  null
  
)

export default component.exports